import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { getCookie } from '../../utils';
import MealPlanIcon from './sidebar-icons/mealPlanIcon';
import ProgressIcon from './sidebar-icons/progressIcon';
import TrainingIcon from './sidebar-icons/trainingIcon';
import VideoIcon from './sidebar-icons/videoIcon';
import ConfIcon from './sidebar-icons/confIcon';
import iconUsers from '../../images/icon-users.svg';
import { loginAsAdmin } from '../../redux/slices/adminAuthSlice';
import logo from '../../images/logo-agc.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch(); 
  const { trainingActive, planActive } = useSelector((state) => state.apiResponses);
  const { userType } = useSelector((state) => state.protect);
  const isAdminLoggedIn = getCookie('adminaccessToken');

  useEffect(() => {
    if (userType === 'admin') {
      var shouldHideDashboard = localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1";
      if (!shouldHideDashboard) {
        navigate('/admin/users');
      } else {
        navigate('/admin/dashboard');
      }

    }
  }, [userType]);

  const handleLoginAsAdmin = () => {
    localStorage.setItem('directlogin', '1');
    dispatch(loginAsAdmin());
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar-container customer-app">
      <div className="sidebar">
        <header className="flex align-center justify-center">
          <a href="https://admin.alexgamblecoaching.com/meal-plan" className="logo text-white flex align-center gap-m">
            <img src={logo} alt="AGC Logo" />
          </a>
        </header>

        <nav>
          <ul>
          {planActive && (
            <li className={isActive('/meal-plan') ? 'nav-active' : ''}>
              <Link to="/meal-plan" className="flex align-center">
                <MealPlanIcon style={{ width: '20px', height: '20px', marginRight: '10px' }} />
                <span>Meal Plan</span>
              </Link>
            </li>
            )}

            {planActive && (
            <li className={isActive('/weight-tracker') ? 'nav-active' : ''}>
              <Link to="/weight-tracker" className="flex align-center">
                <ProgressIcon style={{ width: '20px', height: '20px', marginRight: '10px' }} />
                <span>Progress Tracker</span>
              </Link>
            </li>
            )}

            {planActive && trainingActive && trainingActive == 'YES'  && (
              <li className={isActive('/training') ? 'nav-active' : ''}>
                <Link to="/training" className="flex align-center">
                  <TrainingIcon style={{ width: '20px', height: '20px', marginRight: '10px' }} />
                  <span>Training</span>
                </Link>
              </li>
            )}         

            {planActive && (
            <li className={isActive('/get-started') ? 'nav-active' : ''}>
              <Link to="/get-started" className="flex align-center">
                <VideoIcon style={{ width: '20px', height: '20px', marginRight: '10px' }} />
                <span>Get Started</span>
              </Link>
            </li>
            )}

            <li className={isActive('/configuration') ? 'nav-active' : ''}>
              <Link to="/configuration" className="flex align-center">
                <ConfIcon style={{ width: '20px', height: '20px', marginRight: '10px' }} />
                <span>Configuration</span>
              </Link>
            </li>

            {isAdminLoggedIn && isAdminLoggedIn !== '' && (
              <li>
                <Link onClick={() => handleLoginAsAdmin()} className="flex align-center">
                  <img src={iconUsers} style={{ width: '55px', height: '55px' }} alt="" />
                  <span>Login as Admin</span>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;